export default __webpack_public_path__ + "static/media/imageUpload.3a37e5f5.svg";